

















import Vue from "vue";

const randomId = (): number => Math.floor(Math.random() * 10000);

interface ComponentState {
  uniqueId: number,
}


export default Vue.extend({
  name: "VAutocomplete",
  props: {
    completionOptions: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data(): ComponentState {
    return {
      uniqueId: randomId(),
    };
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
  },
});
